module.exports = __webpack_public_path__ + "img/pc_footer_img.f4f07eb.webp";